module.exports = __webpack_public_path__ + "img/couples-006.054638c0.jpg";